import { Fragment, useMemo } from 'react'
import { splitTextWithBoldLabels } from './quickStudyPure'

interface ComparisonLabelTextProps {
  text: string
  labels?: string[]
  className?: string
}

/** Renders prose with known comparison entity names (e.g. "Creative A", "Landing page A").
 *  The labels are NOT emphasized — they render as plain prose (no bold), matching the rest
 *  of the sentence. The split is still computed so label boundaries stay a single point of
 *  truth, but every segment renders identically. */
export function ComparisonLabelText({ text, labels = [], className }: ComparisonLabelTextProps) {
  const segments = useMemo(() => splitTextWithBoldLabels(text, labels), [text, labels])
  return (
    <span className={className}>
      {segments.map((segment, i) => (
        <Fragment key={i}>{segment.text}</Fragment>
      ))}
    </span>
  )
}
